import * as types from './types'
import ivaApi from '../api'

export const actions = {
    async [types.IVA_FETCH]({commit}, data = null) {
        commit(types.IVA_SET_LOADING, true)
        const response = await ivaApi.all(data)
        commit(types.IVA_OBTAIN, response.data.data)
        commit(types.IVA_META, response.data.meta)
        commit(types.IVA_SET_LOADING, false)
    },
}
